/**
 * @ngdoc directive
 * @name gazelle.components.validation.directive:gzRegexValidator
 *
 * @param {string=} regex property name to retrieve regex to validate against
 *
 * @description
 * `<gz-regex-validator>` is an async form validator, providing for validating a model
 * against a regex property.
 *
 * @example
 * Jade
 * ```jade
   md-input-container
     label(for="name" translate='account.account.Device_Device_Name')
     input#in-name(
     name="name"
     type="text"
     ng-model="vm.device.name"
     required
     md-maxlength="100"
     gz-regex-validator="Validator.AAA.NameUnicode"
   )
   div(ng-messages="vm.form.name.$error")
     div(ng-message='required'): translate uxf.uxf.Required
     div(ng-message='gzRegexValidator'): translate uxf.uxf.Validation_Invalid
 * ```
 */
export const name = 'gzRegexValidator';
export default function gzRegexValidator($q, $gzRegexValidator) {
  'ngInject';

  let directive = {
    require: 'ngModel',
    restrict: 'A',
    link: gzRegexValidatorLink,
  };
  return directive;

  function gzRegexValidatorLink(scope, element, attrs, ctrl) {
    ctrl.$asyncValidators.gzRegexValidator = function(modelValue, viewValue) {
      if (ctrl.$isEmpty(modelValue)) {
        // consider empty model valid
        return $q.resolve();
      }

      return $gzRegexValidator.validate(attrs.gzRegexValidator, modelValue);
    };
  }
}



// WEBPACK FOOTER //
// ../~/@printos/gazelle/src/components/validation/regexValidator.directive.js